import React from "react";
import loadable from "@loadable/component";
import Loader from "../Mobile-mmt-react-native/apps/rails/src/pages/Common/Loader";

const RailsLanding = loadable(
  () =>
    import(
      /* webpackChunkName: "railsLanding" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/RailsLandingPage"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsCalendar = loadable(
  () =>
    import(
      /* webpackChunkName: "railsCalendar" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/Calendar/RailsCalendar"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsMealsThankYou = loadable(
  () =>
    import(
      "../Mobile-mmt-react-native/apps/rails/src/pages/MealsInTrains/Pages/RailsMealsThankYou"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsCityPicker = loadable(
  () =>
    import(
      /* webpackChunkName: "railsCityPicker" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/RailsLandingPage/Pages/RailsCityPicker"
    ),
  {
    fallback: <Loader />,
  }
);

const TrainsBookingPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "trainsBookingPolicy" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/Traveller/Components/TrainsBookingPolicy"
    ),
  {
    fallback: <Loader />,
  }
);

const OtpVerification = loadable(
  () =>
    import(
      /* webpackChunkName: "otpVerification" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/NewUserFlow/OtpVerification"
    ),
  {
    fallback: <Loader />,
  }
);

const CreateNewAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "createNewAccount" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/CreateNewAccount/CreateNewAccount"
    ),
  {
    fallback: <Loader />,
  }
);

const ForgotUsername = loadable(
  () =>
    import(
      /* webpackChunkName: "forgotUsername" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/NewUserFlow/ForgotUsername"
    ),
  {
    fallback: <Loader />,
  }
);
const RailsCreateAccountSuccess = loadable(
  () =>
    import(
      /* webpackChunkName: "railsCreateAccountSuccess" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/CreateNewAccount/RailsCreateAccountSuccessPage"
    ),
  {
    fallback: <Loader />,
  }
);
const RailsPasswordReminder = loadable(
  () =>
    import(
      /* webpackChunkName: "railsPasswordReminder" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/Common/RailsPasswordReminder"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsReviewContainer = loadable(
  () =>
    import(
      /* webpackChunkName: "railsReviewContainer" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/Review/RailsReviewContainer"
    ),
  {
    fallback: <Loader />,
  }
);

const IrctcWebPage = loadable(
  () =>
    import(
      /* webpackChunkName: "irctcWebPage" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/PostPayment/RNWebPostPayment/IrctcWebPage"
    ),
  {
    fallback: <Loader />,
  }
);

const ForgotPassword = loadable(
  () =>
    import(
      /* webpackChunkName: "forgotPassword" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/PostPayment/ForgotPasswordWeb"
    ),
  {
    fallback: <Loader />,
  }
);

const ForgotIrctcPassword = loadable(
  () =>
    import(
      /* webpackChunkName: "forgotIrctcPassword" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/PostPayment/ForgotIrctcPasswordWeb"
    ),
  {
    fallback: <Loader />,
  }
);

const WebViewWrapper = loadable(
  () =>
    import(
      /* webpackChunkName: "webViewWrapper" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/Common/RailsWebViewWrapper"
    ),
  {
    fallback: <Loader />,
  }
);
const BookBreakJourney = loadable(
  () =>
    import(
      /* webpackChunkName: "bookBreakJourney" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/BreakJourney/BookBreakJourney"
    ),
  {
    fallback: <Loader />,
  }
);

const WebViewForError = loadable(
  () =>
    import(
      /* webpackChunkName: "webViewError" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/NewListing/WebViewForError"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsListingAsync = loadable(
  () =>
    import(
      /* webpackChunkName: "railsListing" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/NewListing/RailsListingWebRoutes"
    ),
  {
    fallback: <Loader />,
  }
);

const InfoServiceAsync = loadable(
  () =>
    import(
      /* webpackChunkName: "infoServices" */
      "./InfoServices"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsTravelerAsync = loadable(
  () =>
    import(
      /* webpackChunkName: "railsTraveler" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/TravelerDetails/RailsTravelerWebRoute"
    ),
  {
    fallback: <Loader />,
  }
);

const RailsRetryAsync = loadable(
  () =>
    import(
      /* webpackChunkName: "railsRetry" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/RetryBooking/RailsRetryBookingWebRoute"
    ),
  {
    fallback: <Loader />,
  }
);
const RailsThankYouAsync = loadable(
  () =>
    import(
      /* webpackChunkName: "railsThankYou" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/PostPayment/RailsThankYouWebRoute"
    ),
  {
    fallback: <Loader />,
  }
);

const NeedHelp = loadable(
  () =>
    import(
      /* webpackChunkName: "needHelo" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/NeedHelp"
    ),
  {
    fallback: <Loader />,
  }
);

const ConnectedTravelV2 = loadable(
  () =>
    import(
      /* webpackChunkName: "connectedTravelV2" */
      "../Mobile-mmt-react-native/apps/rails/src/pages/ConnectedTravelV2"
    ),
  {
    fallback: <Loader />,
  }
);

export {
  RailsLanding,
  RailsCalendar,
  RailsCityPicker,
  TrainsBookingPolicy,
  OtpVerification,
  CreateNewAccount,
  ForgotUsername,
  RailsCreateAccountSuccess,
  RailsPasswordReminder,
  RailsReviewContainer,
  IrctcWebPage,
  ForgotPassword,
  ForgotIrctcPassword,
  WebViewWrapper,
  BookBreakJourney,
  WebViewForError,
  RailsListingAsync,
  InfoServiceAsync,
  RailsTravelerAsync,
  RailsRetryAsync,
  RailsThankYouAsync,
  NeedHelp,
  ConnectedTravelV2,
  RailsMealsThankYou
}
